// extracted by mini-css-extract-plugin
export default {"mCard":"FB-z","image":"GB-z","imageNoBackground":"HB-z","imageHasCategory":"IB-z","fullWidth":"JB-z"};